import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import { LayoutCommon } from '../shared/layout';
import { authRoutes } from "@/modules/auth";
import ladingRoutes from "@/modules/ladings/routes";
import {accountRoutes} from "@/modules/account";
import {complaintCustomerRoutes} from "@/modules/complaintcustomer";
import {ladingErrorCustomerRoutes} from "@/modules/ladingerrorcustomer";
import {customerCareRoutes, qARoutes, ruleRoutes, tutorialRoutes} from "@/modules/privacy";
import {manageFeeRoutes} from "@/modules/managefeecustomer";
import manageCodRoutes from "@/modules/managecodcustomer/routes";
import locationRoutes from "@/modules/location/routes";


Vue.use(VueRouter);

export const constantRoutes: Array<RouteConfig> = [
    {
        path: "/",
        component: LayoutCommon,
        name: "home",
        redirect: "/dashboard",
        children: [
            {
                path: "dashboard",
                component: () => import(/* webpackChunkName: "icons" */ "@/modules/dashboard/index.vue"),
                name: 'dashboard',
                meta: {
                    title: 'Trang chủ',
                    icon: 'dashboard',
                    noCache: true
                }
            }
        ]
    },
    ...authRoutes
];

export const asyncRoutes: Array<RouteConfig> = [
    {
        path: "/bill-lading",
        component: LayoutCommon,
        name: "billLading",
        meta: { title: "Đơn hàng", showRoot: true, icon: "transaction" },
        children: [
            ...ladingRoutes,
        ]
    },
    {
        path: "/manage",
        component: LayoutCommon,
        name: "manage",
        meta: { title: "Quản lý", showRoot: true, icon: "transaction" },
        children: [
            {
                path: "bill-lading-lists",
                component: () => import("@/modules/ladings/List/index.vue"),
                name: "listLading",
                props: route => ({query: route.query}),
                meta: { title: "Quản lý đơn hàng" }
            },
            ...manageFeeRoutes,
            ...manageCodRoutes,
            ...locationRoutes
        ]
    },
    {
        path: "/error-complaint",
        component: LayoutCommon,
        name: "billLadingErrorComplaint",
        meta: { title: "Sự cố-Khiếu nại", showRoot: true, icon: "transaction" },
        children: [
            ...complaintCustomerRoutes,
            ...ladingErrorCustomerRoutes,
        ]
    },
    ...tutorialRoutes,
    // ...ruleRoutes,
    // ...qARoutes,
    {
        path: "/account",
        component: LayoutCommon,
        name: "account",
        meta: { title: "Tài khoản", showRoot: true, icon: "setting" },
        children: [
            ...accountRoutes
        ]
    },
    // ...customerCareRoutes,
    {
        path: '*',
        redirect: '/404',
        meta: { hidden: true }
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: constantRoutes.concat(asyncRoutes)
});

export default router
